var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import axios from "axios";
import { to } from "./utils";
export class APIClient {
    constructor(apiHost, apiKey, timeout = 10000) {
        this._apiHost = apiHost;
        this._apiKey = apiKey;
        this._http = axios.create({
            baseURL: this._apiHost,
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${this._apiKey}`,
            },
        });
        this.timeout = timeout;
    }
    get apiHost() {
        return this._apiHost;
    }
    request(method, url, params, data, throwError, timeout) {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function* () {
            const config = {
                url,
                method,
                params,
                data,
            };
            config.headers = {
                "X-Session-ID": this.session || "",
            };
            const { err, res } = yield to(this._http.request(config), timeout || this.timeout);
            if (!(res === null || res === void 0 ? void 0 : res.data)) {
                const errMsg = ((_b = (_a = err === null || err === void 0 ? void 0 : err.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.error) || err || "unknown_error";
                console.error(url, errMsg);
                if (throwError)
                    throw errMsg;
                return null;
            }
            const result = res.data;
            // console.log(url, result);
            if (!result || !result.success || result.error) {
                const errMsg = (result === null || result === void 0 ? void 0 : result.error) || "unknown_error";
                console.log(url, errMsg);
                if (throwError)
                    throw errMsg;
                return null;
            }
            return result.data || result;
        });
    }
    post(url, data, throwError, timeout) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.request("POST", url, undefined, data, throwError, timeout);
        });
    }
    get(url, params, throwError, timeout) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.request("GET", url, params, undefined, throwError, timeout);
        });
    }
    patch(url, data, throwError, timeout) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.request("PATCH", url, undefined, data, throwError, timeout);
        });
    }
    del(url, params, throwError, timeout) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.request("DELETE", url, params, undefined, throwError, timeout);
        });
    }
}
